import {appUrl} from '@frontend/AppUrl'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Создание ссылки на страницу продавца.
export function makeSellerUrl(userId: number): string {
    return NavigationService.makeUrl(
        appUrl().seller.details,
        {id: userId}
    )
}
